import { Component, Input } from '@angular/core';

@Component({
  selector: 'nns-tab-button',
  template: `
    <div class="nns-animated nns-tab-button-line"></div>
    <div class="nns-tab-button-content" flex="none" layout="row" layout-align="start center">
      <nns-icon [icon]="icon"></nns-icon>
      <div class="nns-tab-button-text">{{title}}</div>
      <div class="nns-tab-button-counter" *ngIf="counter">{{counter}}</div>
    </div>
  `,
  styles: [`
    :host{
      padding:0 16px;
      position:relative;
      cursor:pointer;
      text-transform:uppercase;
      font-weight:bold;
      color:#3E4849;
      height:56px;
    }
    .nns-tab-button-text {
      padding:0 2px;
      white-space:nowrap;
    }
    .nns-tab-button-counter {
      color:#0095A7;
      padding: 0 0 0 2px;
    }
    .nns-tab-button-line {
      position:absolute;
      left:0;
      bottom:0;
      width:100%;
      height:0px;
      background:#0095A7;
    }
    :host:hover .nns-tab-button-line,
    :host.active .nns-tab-button-line {
      height:4px;
    }
  `]
})
export class TabButtonComponent {
  @Input() icon;
  @Input() title;
  @Input() counter;
}
